import React from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { ApolloProvider } from 'react-apollo';
import { normalize } from 'polished';
import { client } from './src/apollo/client';
import theme from './src/theme';
import Layout from './src/components/layout/Layout';

const GlobalStyled = createGlobalStyle`
  ${normalize()}

  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+HK:400,500&display=swap&subset=chinese-hongkong');

  * {
    box-sizing: border-box;
    font-family: 'Noto Sans HK', sans-serif;
  }
`;

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement = ({ element }) => {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <React.Fragment>
          <GlobalStyled />
          {element}
        </React.Fragment>
      </ThemeProvider>
    </ApolloProvider>
  );
};
